import { render } from "./GreenboardOption.vue?vue&type=template&id=0ab5885b&scoped=true&ts=true"
import script from "./GreenboardOption.vue?vue&type=script&lang=ts"
export * from "./GreenboardOption.vue?vue&type=script&lang=ts"

import "./GreenboardOption.vue?vue&type=style&index=0&id=0ab5885b&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab5885b"]])

export default __exports__